import React from "react";
import Space from "../../commons/Space";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Titolo from "../../commons/Titolo";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import 'bs5-lightbox';
import SpaceL from "../../commons/SpaceL";
import {Link, useNavigate} from "react-router-dom"; // Importa il componente Link da react-router-dom
import "../../styles/Master.css";
import CaroselloStandard from "../../commons/CaroselloStandard";
import TitoloColore from "../../commons/TitoloColore";
import ago2025 from "../../images/Nuoto/Ago/20240526_124354.jpg"
import foto1 from "../../images/Nuoto/Ago/I medagliati visione d'insieme .jpeg"
import foto2 from "../../images/Nuoto/Ago/Le medaglie.jpeg"
import foto3 from "../../images/Nuoto/Ago/Riccardo 1° nei 50 Rana.png"
import foto4 from "../../images/Nuoto/Ago/Corrado 2° nei 50 Dorso.png"
import foto5 from "../../images/Nuoto/Ago/Lavinia 3^ nei 50 Rana.jpeg"
import foto6 from "../../images/Nuoto/Ago/NIcolas 3° nei 50 Rana.png"
import foto7 from "../../images/Nuoto/Ago/Corrado 2° nei 100 Stile libero.png"


function GarePreAgo() {
    const navigate = useNavigate();
    return (
        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Agonismo"} backgroundColor={"#003F83"} />
            <FrecciaIndietro indirizzo={"/corsinuoto"} />
            <div style={{padding: "1em"}}>
                <h1 className="text-center" style={{fontFamily: "Hammersmith One", padding: "1em"}}>Risultati Gare</h1>

                <div className="text-center">
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/01%20-%2014DIC25%20TORTONA.pdf" download> 14 dicembre 2025 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/03%20-%2025FEB24%20TORTONA.pdf" download> 25 febbraio 2024 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/04%20-%2024MAR24%20TORTONA.pdf" download> 24 marzo 2024 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/05%20-%2021APR24%20MONZA.pdf" download> 21 aprile 2024 - Monza</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/06%20-%2026MAG24%20MONZA.pdf" download> 26 maggio 2024 - Monza</a>

                </div>
                <Space />
                <div className="d-flex flex-row container-news" style={{ overflowX: "auto", marginTop: "1em" }}>
                    <img src={foto1} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto2} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto3} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto4} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto5} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto6} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto7} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={ago2025} className="img-fluid img-thumbnail news-img" alt="..." />
                </div>












                <Space />
            </div>
        </div>
    )
}

export default GarePreAgo;
